import { Link } from 'react-router-dom';

const footerLinks = {
  product: [
    { label: '蜜桃视频', href: '/category?tab=mitao' },
    { label: '桃子视频', href: '/category?tab=taozi' },
    { label: '苹果视频', href: '/category?tab=pingguo' },
    { label: '榴莲视频', href: '/category?tab=liulian' },
    { label: '芒果视频', href: '/category?tab=mangguo' },
    { label: '糖果视频', href: '/category?tab=tangguo' },
  ],
  company: [
    { label: '关于我们', href: '/about' },
    { label: '品牌故事', href: '/about' },
    { label: '发展历程', href: '/about' },
    { label: '联系我们', href: '/about' },
    { label: '加入我们', href: '/about' },
  ],
  support: [
    { label: '帮助中心', href: '/about' },
    { label: '常见问题', href: '/#faq' },
    { label: '用户协议', href: '/about' },
    { label: '隐私政策', href: '/about' },
    { label: '版权声明', href: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-500">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
            <div className="sm:col-span-2 lg:col-span-1">
              <Link to="/" className="flex items-center gap-2 cursor-pointer group mb-4">
                <div className="w-9 h-9 rounded-lg bg-background-50/20 flex items-center justify-center">
                  <i className="ri-heart-fill text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50">
                  糖心视频
                </span>
              </Link>
              <p className="text-background-50/80 text-sm leading-relaxed mb-4">
                汇聚蜜桃视频、桃子视频、苹果视频、榴莲视频、芒果视频和糖果视频六大品牌，提供超清画质、极速播放的在线观影体验。
              </p>
              <div className="flex items-center gap-3">
                <a
                  href="#"
                  className="w-9 h-9 rounded-full bg-background-50/15 flex items-center justify-center cursor-pointer hover:bg-background-50/25 transition-colors"
                  aria-label="微信"
                >
                  <i className="ri-wechat-fill text-background-50 text-base"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 rounded-full bg-background-50/15 flex items-center justify-center cursor-pointer hover:bg-background-50/25 transition-colors"
                  aria-label="微博"
                >
                  <i className="ri-weibo-fill text-background-50 text-base"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 rounded-full bg-background-50/15 flex items-center justify-center cursor-pointer hover:bg-background-50/25 transition-colors"
                  aria-label="抖音"
                >
                  <i className="ri-tiktok-fill text-background-50 text-base"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 rounded-full bg-background-50/15 flex items-center justify-center cursor-pointer hover:bg-background-50/25 transition-colors"
                  aria-label="B站"
                >
                  <i className="ri-bilibili-fill text-background-50 text-base"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-background-50 text-base font-semibold mb-4">品牌频道</h4>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.product.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-background-50/75 text-sm hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-background-50 text-base font-semibold mb-4">关于我们</h4>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.company.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-background-50/75 text-sm hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-background-50 text-base font-semibold mb-4">帮助支持</h4>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.support.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-background-50/75 text-sm hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/15 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-50/60 text-xs">
            &copy; 2026 糖心视频 TangXin Video. All rights reserved.
          </p>
          <p className="text-background-50/50 text-xs">
            糖心视频 | 蜜桃视频 | 桃子视频 | 苹果视频 | 榴莲视频 | 芒果视频 | 糖果视频
          </p>
        </div>
      </div>
    </footer>
  );
}